import styled from 'styled-components';
import { StackProps } from 'components/Stack';
import { Text } from 'components/Typography';

type MessageCoverProps = {
  firstLineMessage: string;
  secondLineMessage?: string;
};

const MessageCover = ({ firstLineMessage, secondLineMessage }: MessageCoverProps) => {
  return (
    <CoverDiv>
      <div style={{ display: 'flex', textAlign: 'center' }}>
        {firstLineMessage}
        {secondLineMessage && (
          <>
            <br /> {secondLineMessage}
          </>
        )}
      </div>
    </CoverDiv>
  );
};

export default MessageCover;

const CoverDiv = styled.div<StackProps>`
  display: flex;
  width: 96%;
  padding: 8px 10px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  flex: 1 0 0;

  ${({ theme }) => ({
    borderRadius: 8,
    // border: `1px solid ${theme.colors.RG06}`,
  })}

  /* body14M */
  color: var(--GrayScale-gray700, #7D818D);
  font-family: 'Pretendard';
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px; /* 171.429% */
  letter-spacing: -0.28px;
`;
